import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectCompletionYearFilter } from 'shared/selectors/advancedFilters';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray, ECompletionYearType } from '../../../../../../../../../packages/JsonQuery';

export const NewbuildingConstructionYearContainer: FC = () => {
  const { value, options, yearOffset, availableCompletionYearTypes } = useSelector(selectCompletionYearFilter);

  const onChange = useFilterChangeCallback();

  const handleCompletionYearChange = useCallback(
    (newValue: NonEmptyArray<ECompletionYearType> | null) => {
      onChange({
        action: 'setCompletionYearTypes',
        arguments: [
          {
            completionYearTypes: newValue,
            yearOffset,
            availableYearTypes: availableCompletionYearTypes,
          },
        ],
      });
    },
    [availableCompletionYearTypes, onChange, yearOffset],
  );

  return <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleCompletionYearChange} />;
};
